import React, { Component } from 'react';
import { shape, arrayOf, number, bool, objectOf, object, string, func } from 'prop-types';
import { defaultTypeOptions as TYPE_OPTIONS, GeoFencing } from './index';
import { getNumberOfChartAndTableInReport } from '../Report/helper';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { GEO_CHART_ID } from '../../../helpers/constant';
import { UNIDENTIFINEDLOCATION } from './constants';
import { defaultChartSelector as DEFAULT_CHART_SELECTORS } from '../../../helpers/defaultInfo';

import {
  updateDataDisplayForGeoTab,
  updateSelectedChartCampaign,
  setChartSelector,
  captureGeoChart
} from '../../../state/modules/app/campaign';
import { loadGeoFenceData, setTargetLocationPath, loadDataByLocationPath } from '../../../state/modules/app/campaign/actions';
import { goToCampaignPage } from '../../../state/modules/routing/actions.js';
import { selectCurrentRoutePayload } from '../../../state/modules/routing';
import { setReportChartSelector } from '../../../state/modules/app/reportBuilder/actions';
import getUrlApi from '../../../helpers/getUrlApi';
import { namespace as locationGranularityNameSpace } from '../../../state/modules/app/locationGranularity/actions';

class GeoFencingWrapper extends Component {
  static propTypes = {
    chartData: object,
    campaign: object,
    campaignGeoSelector: shape({
      value: string,
      label: string
    }),
    isCustomReport: bool,
    showInReportConfig: shape({
      locationChart: bool,
      locationTable: bool,
    }),
    countInReportConfig: shape({
      locationChart: arrayOf(number),
      locationTable: arrayOf(number),
    }),
    reportGeoChartSelectors: arrayOf(objectOf(string)),
    setTargetLocationPath: func,
    geoTableSorters: object,
    loadDataByLocationPath: func,
    loadGeoFenceData: func,
  }

  static defaultProps = {
    showInReportConfig: {},
    countInReportConfig: {
      locationChart: [1],
      locationTable: [1],
    },
  }

  handleSetChartSelector = (index) => (campaignId, GEO_CHART_ID, { type: newTypeSelection }) => {
    const { setReportChartSelector } = this.props;
    setReportChartSelector &&
    newTypeSelection &&
    setReportChartSelector(GEO_CHART_ID, index, { type: newTypeSelection });
  }

  handleCaptureGeoChart = (index) => (campaignId, chartImage, GEO_CHART_ID, chartKey) => {
    const { setReportChartSelector } = this.props;
    setReportChartSelector &&
    chartImage &&
    /***
     * Update report chart selector which looks like:
     * reportBuilder: {
     * chartSelector:
     *  [10]: [
     *    {
     *      type: 'adVisits',
     *      imageForGeoChart: {
     *        src 
     *      }
     *    }
     *  ]
     * }
     */
    setReportChartSelector(GEO_CHART_ID, index, { imageForGeoChart: { src: chartImage }});
  }

  handleSetTargetLocationPath = (index) => (newTargetLocationPath, campaignId, chartKey) => {
    const { setReportChartSelector, setTargetLocationPath } = this.props;
    setReportChartSelector &&
    newTargetLocationPath &&
    /***
     * Update report chart selector which looks like:
     * reportBuilder: {
     * chartSelector:
     *  [10]: [
     *    {
     *      type: 'adVisits',
     *      targetLocationPath: ['1203', '12663']
     *    }
     *  ]
     * }
     */
    setReportChartSelector(GEO_CHART_ID, index, { targetLocationPath: newTargetLocationPath });
    setTargetLocationPath && setTargetLocationPath(newTargetLocationPath, campaignId, chartKey);
  }

  renderContent() {
    const {
      campaign,
      countInReportConfig,
      reportGeoChartSelectors,
      geoTableSorters,
      loadGeoFenceData,
      isCustomReport,
      loadDataByLocationPath,
    } = this.props;
    const { locationChart: chartCount = [], locationTable: tableCount = [] } = countInReportConfig;
    
    // get number of needed geofencing components
    const geoFencingNum = getNumberOfChartAndTableInReport(chartCount, tableCount);

    // get campaign geo selector
    const defaultDataType = get(DEFAULT_CHART_SELECTORS, [GEO_CHART_ID, 'type']);
    const geoTypeOption = get(campaign, ['chartSelector', GEO_CHART_ID, 'type'], defaultDataType);
    const campaignGeoSelector = TYPE_OPTIONS[geoTypeOption];

    return Array(geoFencingNum).fill('_').map((item, index) => {
      const isChartDisplay = chartCount[index] !== 0;
      const isTableDisplay = tableCount[index] !== 0;

      // set geo selector for each GeoFencing
      const geoSelector = reportGeoChartSelectors[index] || {};
      const selectedReportType = geoSelector.type;
      const selectedOption = TYPE_OPTIONS[selectedReportType] || campaignGeoSelector;
      
      // set target location path for each GeoFencing
      const selectedReportLocationPath = geoSelector.targetLocationPath;
      
      // set table sorter
      const tableSorter = geoTableSorters[index];

      const key = `GeoFencing-${index}`;
      const isElementDisplay = isChartDisplay || isTableDisplay;
      return isElementDisplay ?
            <GeoFencing
              {...this.props}
              key={key}
              itemIndex={index}
              isCustomReport={isCustomReport}
              loadGeoFenceData={loadGeoFenceData}
              captureGeoChart={this.handleCaptureGeoChart(index)}
              targetLocationPath={selectedReportLocationPath}
              tableSorter={tableSorter}
              setChartSelector={this.handleSetChartSelector(index)}
              setTargetLocationPath={this.handleSetTargetLocationPath(index)}
              selectedOption={selectedOption}         
              showInReportConfig={{
                locationChart: isChartDisplay,
                locationTable: isTableDisplay
              }}
              loadDataByLocationPath={loadDataByLocationPath}
            /> : null;
    })
  }

  render(){
    return (
      <div>
        {this.renderContent()}
      </div>
    )
  }
}

const ConnectedGeoFencingWrapper = connect(
  (state, props) => {    
    const currentStep = get(state, 'reportBuilder.currentStep', '');
    const isTemplateModified = get(state, 'reportBuilder.isTemplateModified', false);
    const reportGeoChartSelectors = get(props, ['reportChartSelector', GEO_CHART_ID]) || 
                                    get(state, ['reportBuilder', 'chartSelector', GEO_CHART_ID], []);
    const geoTableSorters = get(props, ['reportTableSortSelector', GEO_CHART_ID]) || 
                            get(state, ['reportBuilder', 'tableSortSelector', GEO_CHART_ID], {});

    const { campaign, chartData } = props;
    const includeUnidentifiedLocation = get(campaign, 'include_undefined_location', false);
    const geoData = get(chartData, [GEO_CHART_ID, 'data'], {});
    const identifiedCountryIds = Object.keys(geoData).reduce((acc, item) => {
      if (UNIDENTIFINEDLOCATION.indexOf(item) === -1) {
        acc.push(item);
      }
      return acc;
    }, []);
    const appSetting = get(state, 'appSetting.data', []);
    const locationGranularity = get(state, [locationGranularityNameSpace, 'data'], [])

    return {
      urlApi: getUrlApi(state),
      currentPayload: selectCurrentRoutePayload(state),
      reportGeoChartSelectors,
      geoTableSorters,
      includeUnidentifiedLocation,
      identifiedCountryIds,
      currentStep,
      appSetting,
      locationGranularity,
    }
  }, {
    navigateCampaignWithTab: goToCampaignPage,
    updateDataDisplayForGeoTab,
    updateSelectedChartCampaign,
    setChartSelector,
    captureGeoChart,
    loadGeoFenceData,
    setTargetLocationPath,
    setReportChartSelector,
    loadDataByLocationPath,
  }
)(GeoFencingWrapper);
export default ConnectedGeoFencingWrapper;

